export default {"src":"/_next/static/media/paid.af1e95c9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};